import { Route, AppId, createPageRoute } from '@lumapps/router';

export const mobileAnalyticsRoute: Route = createPageRoute({
    slug: 'analytics/mobile',
    id: 'mobile-analytics',
    appId: AppId.backOffice,
});
